export const title: TitleSlide = {
    text: {
        headline: 'Antoine Guenet',
        text: `Insatiably curious, Antoine Guenet is an ever-moving, versatile musician. Over the course of the last decade, he's released a handful of albums and worked on many projects, each as unlike the other as it gets. This curiosity has made him a unique pianist/multi-instrumentalist and composer with a vocabulary extending to all sorts of music.`,
    },
    background: {
        url: 'https://static.wixstatic.com/media/1042fa_9f3145267390fce3ac87d277aa84dac6.jpg?dn=309526_300959009929418_184567974901856_1147982_2103736822_n.jpg',
    }
};

export const events: Slide[] = [{
        start_date: {
            year: 2005,
        },
        end_date: {
            year: 2006,
        },
        text: {
            headline: 'JazzStudio',
            text: `Studying jazz piano at JazzStudio, Antwerp with Jeremy Calbert`,
        },
        media: {
            url: 'http://www.jazzstudio.be/wp-content/themes/jazzstudio/img/logo.svg',
        }
    },
    {
        start_date: {
            year: 2006
        },
        end_date: {
            year: 2011
        },
        text: {
            headline: 'Conservatory',
            text: `Studying jazz piano at Ghent Conservatory with Erik Vermeulen`
        },
        background: {
            url: 'https://www.hogent.be/www/cache/file/A1657134-C6C5-428C-B42F5570EEFE1974_banner.jpg'
        }
    },
    {
        start_date: {
            year: 2007,
            month: 10,
            day: 13
        },
        text: {
            headline: 'PaNoPTiCoN',
            text: `Joining PaNoPTiCoN (improvisation collective)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=Q7vctsYJ64A'
        },
        background: {
            url: 'https://e.snmc.io/lk/f/a/d0a35f124eba820285cb1d88b7d04267/2717570.jpg'
        }
    },
    {
        start_date: {
            year: 2008,
            month: 4,
            day: 1
        },
        end_date: {
            year: 2008,
            month: 4,
            day: 5
        },
        text: {
            headline: 'JIMS',
            text: `Week-long composition masterclass (JIMS) with Lisa Bielawa in Salzburg, Austria`
        },
        background: {
            url: 'https://nationalsawdust.org/wp-content/uploads/2017/03/Lisa-Bielawa-header-1.jpg'
        }
    },
    {
        start_date: {
            year: 2008,
            month: 4,
            day: 30
        },
        text: {
            headline: 'Silence in Wonderland (Det allra viktigaste)',
            text: `Release of Silence in Wonderland (Det allra viktigaste) by (S)hhh (self-released)`
        },
        media: {
            url: 'https://soundcloud.com/user-528197548/03-ijskoud'
        },
        background: {
            url: 'http://www.jazzinbelgium.com/photos/data_albums/00670/scan_cover/shhh_cd_225.jpg'
        }
    },
    {
        start_date: {
            year: 2009
        },
        text: {
            headline: 'Fragmented',
            text: `Recording of "Fragmented" by AG3io "Strong & Wrong" (unreleased)`
        },
        media: {
            url: 'https://a4-images.myspacecdn.com/images03/34/c7446d35cdba4e479e7a5a1995aaed70/300x300.jpg'
        },
        background: {
            url: 'https://a4-images.myspacecdn.com/images03/34/c7446d35cdba4e479e7a5a1995aaed70/300x300.jpg'
        }
    },
    {
        start_date: {
            year: 2011
        },
        text: {
            headline: 'SH.TG.N meets Fulco',
            text: `First project as Artist in Residence for the Gentse Feesten: SH.TG.N meets Fulco Ottervanger`
        },
        media: {
            url: 'http://www.youtube.com/watch?v=jK4B6o7AZFA'
        },
        background: {
            url: 'https://f4.bcbits.com/img/a0561250229_16.jpg'
        }
    },
    {
        start_date: {
            year: 2011
        },
        text: {
            headline: 'Galerie',
            text: `Writing the music for "Galerie" by French contemorary dance company La Locomotive`
        },
        media: {
            url: 'http://www.youtube.com/watch?v=1K84f4vKsmY'
        },
        background: {
            url: 'http://www.lalocomotive.me/wp-content/uploads/2016/11/locomotive_logo.jpg'
        }
    },
    {
        start_date: {
            year: 2012
        },
        text: {
            headline: 'SH.TG.N',
            text: `Release of "SH.TG.N" by SH.TG.N (MoonJune Records, NY, USA)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=xZqfoCteOiA'
        },
        background: {
            url: 'https://f4.bcbits.com/img/a0561250229_16.jpg'
        }
    },
    {
        start_date: {
            year: 2012
        },
        text: {
            headline: 'AG8tet',
            text: `Second project as Artist in Residence for the Gentse Feesten: AG8tet`
        },
        media: {
            url: 'http://www.youtube.com/watch?v=g4vZOUxZC2I'
        },
        background: {
            url: 'http://ag8tet.moonfruit.com/communities/0/004/010/248/850/images/4575402612_420x252.png'
        }
    },
    {
        start_date: {
            year: 2013,
            month: 6,
            day: 25
        },
        text: {
            headline: 'After the Exhibition',
            text: `Release of "After the Exhibition" by The Wrong Object (MoonJune Records, NY, USA)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=O1squr7SKiM'
        },
        background: {
            url: 'https://f4.bcbits.com/img/a1283123228_16.jpg'
        }
    },
    {
        start_date: {
            year: 2013
        },
        text: {
            headline: 'Fluxx',
            text: `Third and last project as Artist in Residence for the Gentse Feesten: Fluxx`
        },
        media: {
            url: 'http://www.youtube.com/watch?v=NayXVFom5CU'
        },
        background: {
            url: 'https://fluxxuniverses.files.wordpress.com/2013/07/cropped-fluxx3.jpg'
        }
    },
    {
        start_date: {
            year: 2014
        },
        text: {
            headline: 'Phosphorescent Dreams',
            text: `Release of "Phosphorescent Dreams" by Univers Zéro (Arcangelo, Japan)`
        },
        media: {
            url: 'https://soundcloud.com/univers-zero/univers-zero-excerpts-from-phosphorescent-dreams-2014'
        },
        background: {
            url: 'https://img.discogs.com/XWlgPBbeqwvWq_rnFHfXdFTtr4o=/fit-in/550x496/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-5525368-1395615662-9597.jpeg.jpg'
        }
    },
    {
        start_date: {
            year: 2014,
            month: 3,
            day: 22
        },
        text: {
            headline: `Zappa's 200 Motels @ de Singel`,
            text: `Performing Frank Zappa's '200 Motels' @ de Singel w/ Brussels Philharmonic + The Wrong Object + Brussel Radio Koor + Robert Martin + Alexander Hanson`,
        },
        media: {
            url: 'http://www.youtube.com/watch?v=K0K_dhVzAn8'
        },
        background: {
            url: 'https://images-na.ssl-images-amazon.com/images/I/51rT9yCrX1L._SX355_.jpg'
        }
    },
    {
        start_date: {
            year: 2014,
            month: 10,
            day: 13
        },
        text: {
            headline: 'SongsNotBombs',
            text: `RUNtoSeed @ Opéra de la Monnaie w/ An Pierlé & Marie Daulne (Zap Mama) after winning the SongsNotBombs songwriting competition`
        },
        media: {
            url: 'http://www.youtube.com/watch?v=JlsmQkqsktY'
        },
        background: {
            url: 'https://dkv1m6tr6w4ev.cloudfront.net/picture/1740/original/grande-salle-grote-zaal.jpg'
        }
    },
    {
        start_date: {
            year: 2015,
            month: 2,
            day: 7
        },
        text: {
            headline: 'Jazz04 Meets Electro',
            text: `Creation and performance by The Gödel Codex for Jazz04 Meets Electro`
        },
        media: {
            url: 'https://soundcloud.com/michel-delville/the-godel-codex-oak-live-premix-2015'
        },
        background: {
            url: 'https://i1.sndcdn.com/artworks-000102721040-i03gjb-t500x500.jpg'
        }
    },
    {
        start_date: {
            year: 2015
        },
        text: {
            headline: 'For Children',
            text: `Recording of "For Children" by Antoine Guenet Trio (unreleased)`
        },
        media: {
            url: 'https://soundcloud.com/antoine-guenet-trio/for-children-bartok-guenet-1'
        },
        background: {
            url: 'https://i1.sndcdn.com/avatars-000141578284-adpx7n-t500x500.jpg'
        }
    },
    {
        start_date: {
            year: 2016,
            month: 10
        },
        text: {
            headline: 'Many Years',
            text: `Release of "Many Years" by Beautiful Badness (Jo And Co, France)`
        },
        media: {
            url: 'http://www.youtube.com/watch?v=3tEjpoJYhOc'
        },
        background: {
            url: 'https://images-na.ssl-images-amazon.com/images/I/6192QBxz7ML._SS500.jpg'
        }
    },
    {
        start_date: {
            year: 2017,
            month: 7,
            day: 21
        },
        text: {
            headline: 'Plays Hendrix',
            text: `Release of "Plays Hendrix" by Machine Mass (MoonJune Records, NY, USA)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=GQ2kz2CUuOU'
        },
        background: {
            url: 'https://f4.bcbits.com/img/a3973658163_16.jpg'
        }
    },
    {
        start_date: {
            year: 2018,
            month: 11,
            day: 24
        },
        text: {
            headline: 'Zappa Jawaka',
            text: `Release of "Zappa Jawaka" by The Wrong Object (Off Records, Belgium)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=tfN1-Y1pRx4'
        },
        background: {
            url: 'http://www.antoineguenet.com/images/jwk.jpg'
        }
    },
    {
        start_date: {
            year: 2019,
            month: 2,
            day: 1
        },
        text: {
            headline: 'Oak',
            text: `Release of "Oak" by The Gödel Codex (Off Records, Belgium) - Release concert at Les Chiroux (Liège, Belgium)`
        },
        media: {
            url: 'https://youtu.be/J2jyx-RiPaU'
        },
        background: {
            url: 'http://www.antoineguenet.com/images/oak.jpg'
        }
    },
    {
        start_date: {
            year: 2019,
        },
        text: {
            headline: 'Into the Herd',
            text: `Release of "Into the Herd" by The Wrong Object (Off Records, Belgium)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=iFnCSqPIr1M'
        },
        background: {
            url: 'http://www.antoineguenet.com/images/hrd.jpg'
        }
    },
    {
        start_date: {
            year: 2020,
        },
        text: {
            headline: 'Rewind',
            text: `Release of "Rewind" by Beautiful Badness (Jo&Co, France)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=r9lfqULMPfo'
        },
        background: {
            url: 'http://www.antoineguenet.com/images/rew.jpeg'
        }
    },
    {
        start_date: {
            year: 2021,
        },
        text: {
            headline: 'Intrusion',
            text: `Release of "Intrusion" by Machine Mass Sextet (Off Records, Belgium)`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=ZjCjJivqfHQ'
        },
        background: {
            url: 'http://www.antoineguenet.com/images/int.jpg'
        }
    },
    {
        start_date: {
            year: 2022,
        },
        text: {
            headline: 'New song cycle in the making',
            text: `Release of The Storm, Siren, The River and Jean's Memory, the first four episodes in an anthology series in music. Siren came with an AI-illustrated book and The River and Jean's Memory with a music video made with AI-generated/transformed images.`
        },
        media: {
            url: 'https://www.youtube.com/watch?v=AzR0fPMp2oA'
        },
        background: {
            url: 'http://www.antoineguenet.com/images/siren.jpg'
        }
    },
    {
        start_date: {
            year: 2023,
        },
        text: {
            headline: 'Moving Slow Burn forward - Lapin Blanc exhibition',
            text: `Release of Innocent, fifth episode of Slow Burn, along with its music video made of a mix of traditional animation, filmed images, and AI-generated/transformed images. This and the three previous releases are part of the Lapin Blanc exhibition around the use of AI in art, at gallery La Conciergerie in Savoie (France).`
        },
        media: {
            url: 'https://youtu.be/EV7pifgfAWc'
        },
        background: {
            url: 'http://www.antoineguenet.com/images/innocent.jpg'
        }
    },
];
